import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlusSignGreenSvgComponent } from './plus-sign-green.component';

@NgModule({
  declarations: [
    PlusSignGreenSvgComponent
  ],
  imports: [
    CommonModule
  ], exports:[
    PlusSignGreenSvgComponent
  ]
})
export class PlusSignGreenSvgModule { }
